type AppStorageKey = ('tenant' | 'tenantName' | 'UserName' | 'Pass' | 'localization' | 'pk' | 'tenantInfo' | 'access_token' | '__tenant');

export class AppStorage {

  static readonly app = 'iam-m-invoice-react.v1.0.0';

  static set(key: AppStorageKey, value: string): void {
    localStorage.setItem(`${this.app}_${key}`, value);
  }

  static get(key: AppStorageKey): string {
    return localStorage.getItem(`${this.app}_${key}`) || '';
  }

  static remove(key: AppStorageKey): void {
    localStorage.removeItem(`${this.app}_${key}`);
  }

}

export class AppCookie {

  static get(cname: string): string {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

}
